import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { tipoMenuEnum } from '../../enum/index';

const SubMenu = (props) => {

  const [subnav, setSubnav] = useState(false);
  const { SideBarData, item, showSidebar } = props;

  const validar = (item) => {
    SideBarData.map((dato) => {
      if (item?.tipo === tipoMenuEnum.SubMenu) {
        if (item.id !== dato.id) {
          dato.estado = false;
        }
      }
    })
  }

  const showSubnav = () => {
    setSubnav(!subnav)
    if (item.estado) {
      item.estado = false;
    } else {
      if (!item.estado) {
        item.estado = true;
      }
    }
    validar(item);
  }

  return (
    <>
      <li className={'nav-text'}>
        <Link
          to='#'
          onClick={item.subNav && showSubnav}>
          {item.icon}
          <span>{item.title} </span>
          <div className="expand-sub-menu">
            {item.subNav && item.estado
              ? item.iconOpened
              : item.subNav
                ? item.iconClosed
                : null}
          </div>
        </Link>
      </li>
      {item.estado === true &&
        item.subNav.map((item, index) => {
          return (
            <li key={index} className={'nav-text'}>
              <span></span>
              <Link to={item.path} onClick={showSidebar}>
                {item.icon}
                <span>{item.title}</span>
              </Link>
            </li>
          );
        })}
    </>
  );
};

export default SubMenu;